export const subscriptionsHeaders = [
  'product',
  'plan',
  'price',
  'payment_method',
  'next_charge',
  'created_at'
]
